import { useState, useEffect } from 'react';
import { Button } from '../../common/components/Button';
import { Modal } from '../../common/components/Modal';
import { verificationIdParam } from '../../routes';
import {
  getRedirectUrlForProcess,
  handleRedirect,
} from '../../common/services/process';
import { listOfUnknownBanks, useSendAspspMutation } from './aspspQueries';
import { unknownBankId } from '.';
import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';
import { ReactComponent as ExclamationIcon } from 'src/assets/icons/exclamation.svg';
import ReactMarkdown from 'react-markdown';

const Body = styled.div`
  margin: 2rem 0;
  min-height: 25vh;
`;

const Title = styled.h4`
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  text-align: center;

  ${media.w.min.px576(css`
    font-size: 1.125rem;
  `)}
`;

const Description = styled.div`
  margin: 1.5rem 0;
  color: ${({ theme }) => theme.text.secondary};
  text-align: justify;
  font-size: 0.8125rem;

  ${media.w.min.px576(css`
    font-size: 1rem;
  `)}
`;

const Icon = styled(ExclamationIcon)`
  flex-shrink: 0;
  margin-right: 1rem;
  width: 2rem;
  height: 2rem;
  color: ${({ theme }) => theme.colors.primary};

  ${media.w.min.px576(css`
    width: 2.5rem;
    height: 2.5rem;
  `)}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
`;
const StyledReactMarkdown = styled(ReactMarkdown)`
  white-space: pre-wrap;
`;

const UnknownBankWarning = () => {
  const [isOpen, setIsOpen] = useState(true);
  const verificationId = localStorage.getItem(verificationIdParam);
  const [selectedBank, setSelectedBank] = useState('');
  const [unknownBanks, setUnknownBanks] = useState<string[]>([]);

  useEffect(() => {
    if (verificationId) {
      listOfUnknownBanks(verificationId).then((response) => {
        const banks = response.data.otherAspsp;
        setUnknownBanks(banks);
      });
    }
  }, [verificationId]);

  const sendAspspMutation = useSendAspspMutation();

  const handleChange =  (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBank(event.target.value);
  };

  const redirect = () => {
    
    if (verificationId) {
      sendAspspMutation.mutateAsync({
        aspspId: unknownBankId,
        verificationId: verificationId!,
        otherBank: selectedBank,
      });
      getRedirectUrlForProcess(verificationId)
        .then(({ redirectUrl }) => {
          handleRedirect(redirectUrl);
        })
        .finally(() => setIsOpen(false));
    } else {
      console.error('No verificationId');
    }
  };

  return <Modal open={isOpen} onClose={() => { }}>
    <div className="popup">
      <Header>
        <Icon />
        <Title>Przepraszamy za niedogodność, wkrótce dodamy więcej banków do listy.</Title>
      </Header>
      <Body>
        <Description>
          <StyledReactMarkdown>Prosimy o wybranie swojego banku z poniższej listy. Po dokonaniu wyboru będziesz mógł wrócić na stronę partnera i rozpocząć ponownie proces.</StyledReactMarkdown>
        </Description>

        <div style={{ textAlign: 'center', padding: '20px' }}>
          <select id="bank-select" value={selectedBank} onChange={handleChange} style={{ padding: '10px', borderRadius: '4px', fontFamily: 'inherit' , width: '100%'}}>
            <option value="" disabled>Wybierz bank</option>
            {unknownBanks && unknownBanks.length > 0 ? (
              unknownBanks.map((bank) => <option key={bank} value={bank}>{bank}</option>)
            ) : (
              <option value="" disabled>Brak dostępnych banków</option>
            )}
          </select>
        </div>
        <Button disabled={selectedBank === ''} onClick={redirect}>Wróć do strony partnera</Button>
      </Body>
      
    </div>
  </Modal>;
};

export default UnknownBankWarning;
